<template>
  <div v-loading="listLoading" class="app-container">
    <div class="searchContainer">
      <div class="searchLeft">
        <el-button
          v-permit:remove="'btn:payableManagement:payableCollection:export'" size="small" type="primary"
          @click="operationBtn"
        >
          {{ $t('receivablePayable.Export') }} <!--导出-->
        </el-button>
        <!--自定义栏目-->
        <CustomStatusBar
          class="feet-btn"
          :columns-data="PAYABLE_DETAIL_TABLE_COLUMNS"
          :params="searchParams"
          :save-params="customParams"
          @updateColumns="updateColumns"
        />

        <TipsCmp :row="statisticalData" />
      </div>

      <!--查询-->
      <el-button
        icon="el-icon-search" size="small" type="primary"
        @click="searchResources()"
      >{{ $t('receivablePayable.Search') }}
      </el-button>
    </div>

    <el-divider />

    <div>
      <el-table
        ref="elTable"
        :key="tableKey"
        :data="tableData"
        :height="tableHeight"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        />
        <el-table-column :label="$t('operationCenter.ind')" align="center" width="60px">
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in currentColumns"
          :key="index"
          :align="item.fixed"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <!--业务类型-->
            <div v-if="item.prop === 'businessType'">
              <div>
                <!--揽收-->
                <span v-if="scope.row.businessType === 2">{{ $t('collectionCenter.lanshou') }}</span>
                <!--派送-->
                <span v-else-if="scope.row.businessType === 3">{{ $t('collectionCenter.dispatch') }}</span>
                <!--转运-->
                <span v-else-if="scope.row.businessType === 1">{{ $t('collectionCenter.turnTransport') }}</span>
              </div>
            </div>
            <!--揽收方式-->
            <div v-else-if="item.prop === 'collectType'">
              {{ scope.row[item.prop] === 1 ? $t('collectionCenter.dropOff') : $t('collectionCenter.doorPickUp') }}
            </div>
            <div v-else-if="item.prop === 'merchantCode'">
              {{ scope.row[item.prop] }}{{ scope.row['merchantName']?`(${scope.row['merchantName']})`:'' }}
            </div>
            <!--AJD显示账号类型 customerType 1 自营 2 第三方-->
            <div v-else-if="item.prop === 'customerType'">
              {{ scope.row.customerType === 1
                ? $t('GlobalSetObj.selfSupport')
                : scope.row.customerType === 2 ? $t('GlobalSetObj.three') : ''
              }}
            </div>
            <!--路线类型-->
            <div v-else-if="item.prop === 'routeType'">
              {{
                TRANSPORTATION_TYPE[scope.row.routeType] && TRANSPORTATION_TYPE[scope.row.routeType].label || ''
              }}
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, ind) in getCurrentColumns"
          :key="ind + 100"
          :align="item.fixed"
          :label="item.label"
          :prop="item.prop"
          :show-overflow-tooltip="true"
          :width="item.width"
        >
          <template slot-scope="scope">
            <div>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getExamineTableData"
          @size-change="getExamineTableData"
        />
      </div>
    </div>

    <!--  查询  -->
    <el-drawer
      :append-to-body="true"
      :title="$t('receivablePayable.Search')"
      :visible.sync="showSearch"
      custom-class="drawerClass"
      direction="rtl"
      size="50%"
    >
      <search-form
        :is-read-only="true"
        :select-key="2"
        :payable-type="billBatchData.payableType"
        :bill-batch-number="batchNumber"
        @search="searchFun"
        @close="showSearch = false"
      />
    </el-drawer>
  </div>
</template>

<script>
import {
  apiPayableSiteExpenseCountTotalFree,
  apiPayableSiteExpenseExport,
  apiPayableSiteExpenseGetPage
} from '@/api/finance/receivables';
import { cloneDeep } from 'lodash-es';
import { goResourceTaskList } from '@/utils/goExportList.js';
import { ORDER_TYPE_LIST, WAYBILL_STATUS } from '@/views/finance/enums.js';
import { SEARCH_PARAMS } from '@/views/finance/payableManage/feesPayable/enums.js';
import { PAYABLE_DETAIL_TABLE_COLUMNS } from '@/views/finance/payableManage/payableCollection/enums';
import { TRANSPORTATION_TYPE } from '@/views/finance/utils';

export default {
  name: 'BatchNumberDetail',
  components: {
    searchForm: () => import('@/views/finance/payableManage/feesPayable/component/QuerySearchCmp.vue'),
    CustomStatusBar: () => import('@/components/customStatusBar/index.vue'),
    TipsCmp: () => import('@/views/finance/payableManage/cmp/TipsCmp.vue')
  },
  props: {
    // 收款单号
    batchNumber: {
      type: String,
      default: ''
    },
    // 列表详情
    billBatchData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      PAYABLE_DETAIL_TABLE_COLUMNS,
      TRANSPORTATION_TYPE,
      // 物流订单
      WAYBILL_STATUS,
      // 揽收订单
      ORDER_TYPE_LIST,
      queryForm: {
        orderDirection: 'DESC',
        orderProperty: '',
        pageNumber: 1,
        pageSize: 10,
        params: {
          ...SEARCH_PARAMS
        }
      },
      total: 0,
      tableData: [],
      listLoading: false,
      currentColumns: [],
      getCurrentColumns: [],
      selectData: [],
      showSearch: false,
      tableHeight: 0,
      // 详情统计数据
      statisticalData: {
        providerName: 0, // 应付主体
        siteName: 0, // 应付网点
        totalFree: 0, // 总费用
        totalFeeQty: 0, // 总票数
        averageFee: 0 // 平均每票费用
      },
      tableKey: new Date().getTime(),
      searchParams: {
        type: 0,
        menuEnum: 'payablePaymentDetails'
      },
      customParams: {
        templateField: '',
        templateName: '应付核付详情',
        userId: '',
        type: 0,
        menuEnum: 'payablePaymentDetails'
      }
    };
  },

  created() {
    this.tableHeight = document.body.clientHeight - 280;
    this.queryForm.params.payableNumber = this.batchNumber;
    this.getExamineTableData();
    this.asyncApiPayableSiteExpenseCountTotalFree();
  },
  mounted() {
    // 页面加载的时候设置table的高度
    this.tableHeight = document.body.clientHeight - 280;
    // 页面大小该变的时候（缩放页面）设置table的高度（可加可不加）
    window.onresize = () => {
      this.tableHeight = document.body.clientHeight - 280;
    };
  },
  methods: {
    // 更新自定义栏目columns
    updateColumns(list) {
      this.$nextTick(() => {
        this.$refs.elTable.doLayout();
        this.currentColumns = cloneDeep(list);
        this.tableKey = new Date().getTime();
      });
      // console.log(list, '列表呈现的columns');
    },
    // 列表数据勾选
    handleSelectionChange(arr) {
      this.selectData = arr;
    },
    // 操作
    operationBtn() {
      const ids = [];
      this.selectData.map(list => {
        ids.push(list.id);
      });
      const prop = [];
      const label = [];
      this.currentColumns.map(item => {
        if (item.prop !== 'customerAlias') {
          prop.push(item.prop);
          label.push(item.label);
        }
      });

      const param = {
        ...this.queryForm.params,
        fieldList: prop,
        headList: label,
        ids: ids
      };
      apiPayableSiteExpenseExport(param).then(res => {
        if (res.code === 200) {
          return goResourceTaskList();
        }
      }).then(res => {
        if (res) {
          this.$emit('closeDetail');
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 打开查询弹窗
    searchResources() {
      this.showSearch = true;
    },
    // 获取列表
    getExamineTableData() {
      const param = cloneDeep(this.queryForm);
      this.getCurrentColumns = [];
      this.listLoading = true;
      // 获取列表数据
      apiPayableSiteExpenseGetPage(param, false).then(resp => {
        if (resp.code === 200) {
          this.tableData = resp.data.map(arr => {
            // 物流订单 WAYBILL_STATUS    揽收订单 orderTypeList
            // 应付的业务类型是揽收的取揽收订单的状态，业务类型是派送的取快递物流订单的状态
            if ((arr.businessType === 3 || arr.businessType === 7) && arr.status) {
              /**
               * 1、业务类型 businessType 为 3，订单状态展示【物流订单】的运单状态
               */
              const s1 = this.WAYBILL_STATUS.find(item => item.code === arr.status) || '';
              arr.status = s1.label;
            } else if (arr.businessType === 2 && arr.status) {
              /**
               * 2、业务类型 businessType 为 2，订单状态展示【揽收订单】的订单状态
               */
              const s2 = this.ORDER_TYPE_LIST.find(item => item.collectStatus === arr.status) || '';
              arr.status = s2.collectStatusName;
            } else {
              arr.status = '';
            }
            return arr;
          });
          this.total = resp.total;
          if (resp.data.length > 0) {
            this.getCurrentColumns = [];
            resp.columns.map(item => {
              const obj = {
                prop: item.prop,
                // label: item.label.split('_')[0],
                label: item.label,
                width: 140,
                fixed: 'left',
                highlight: false
              };
              this.getCurrentColumns.push(obj);
              this.$nextTick(() => {
                this.$refs.elTable.doLayout();
                this.rowSelectFlag = true;
                this.tableData.map(list => {
                  const matchedIndex = this.selectData.findIndex(itemList => itemList.id === list.id);
                  this.$refs.elTable.toggleRowSelection(list, matchedIndex !== -1);
                });
                this.rowSelectFlag = false;
              });
            });
          }
        }
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.listLoading = false;
      });
    },
    // 查询
    searchFun(params) {
      this.showSearch = false;
      this.queryForm.params = params;
      this.queryForm.pageNumber = 1;
      this.getExamineTableData();
      this.asyncApiPayableSiteExpenseCountTotalFree();
    },
    // 获取详情总数据
    asyncApiPayableSiteExpenseCountTotalFree() {
      apiPayableSiteExpenseCountTotalFree(this.queryForm.params).then(res => {
        const data = res.data || {};
        const { providerName, siteName, totalFree, totalFeeQty, averageFee } = data;

        Object.assign(this.statisticalData, {
          providerName,
          siteName,
          totalFree: totalFree || 0,
          totalFeeQty: totalFeeQty || 0,
          averageFee: averageFee || 0
        });
      }).catch(err => {
        console.error(err);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.searchContainer {
  display: flex;
  justify-content: space-between;

  .searchLeft {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}
</style>
